export const errorListaDePreciosVacia = "Debe seleccionar una 'Lista de Precio' para agregar artículos al pedido, por favor verifique.";
export const errorCamposRequeridos = "* Faltan completar datos requeridos, por favor verifique.";